import { useEffect, useState } from "react";
/**
 * @typedef {Object} CameraDevice
 * @property {string} deviceId
 * @property {string} label    Falls back to `Camera N` when the label is empty
 *                             (browser hides labels until camera permission is granted).
 * @property {string} [groupId]
 */
/**
 * Enumerates available video input devices and watches for `devicechange` events.
 * Returns an empty array on environments that lack `navigator.mediaDevices`.
 *
 * @returns {CameraDevice[]}
 */
export function useCameras() {
    const [cameras, setCameras] = useState([]);
    useEffect(() => {
        if (!navigator.mediaDevices?.enumerateDevices) {
            return undefined;
        }
        let cancelled = false;
        async function enumerate() {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                if (cancelled)
                    return;
                setCameras(devices
                    .filter((d) => d.kind === "videoinput")
                    .map((d, index) => ({
                    deviceId: d.deviceId,
                    label: d.label || `Camera ${index + 1}`,
                    groupId: d.groupId,
                })));
            }
            catch (_error) {
                // Browser refused enumeration (no permissions, etc.). Leave list empty.
            }
        }
        enumerate();
        const handler = () => { void enumerate(); };
        navigator.mediaDevices.addEventListener?.("devicechange", handler);
        return () => {
            cancelled = true;
            navigator.mediaDevices.removeEventListener?.("devicechange", handler);
        };
    }, []);
    return cameras;
}
//# sourceMappingURL=useCameras.js.map